import React from "react";

import CallToAction from "../components/general/callToAction";

const Products = () => {
  const products = [
      {
        title: "SKOOLTOOL",
        desc: "A Comprehensive Solution for all Your Academic Needs. Make your academic processes easier with our advanced school management software.",
        img: "assets/img/case/skooltool.webp",
        link: "https://myskooltool.com/"
      },
      {
        title: "ACADEMY",
        desc: "At Abia Tech Hub Academy, With our comprehensive courses and expert instructors, we empower students to embark on successful careers.",
        img: "assets/img/case/ath-academy.webp",
        link: "https://academy.abiatechhub.com/"
      },
      {
        title: "CRETEHOST",
        desc: "CreteHost is a reliable web hosting platform, cretehost offers secure and scalable hosting solutions for businesses and individuals.",
        img: "assets/img/case/cretehost.webp",
        link: "https://cretehost.com/"
      },
      {
        title: "Retail POS",
        desc: "Retail POS is a versatile and elegant Point of Sale application with features like Invoicing, Inventory Management, and more.",
        img: "assets/img/case/abiatechhub.webp",
        link: "https://pos.abiatechhub.com/"
      }
  ];

  return (
  <>
    {/* <PageHeader title="Our Products" breadcrumb="Products" /> */}

    <section className="case-study-wrapper section-padding revamp-header-spacer">
        <div className="container">
            <div className="row mb-50 align-items-center">
                <div className="col-12 text-center">
                    <div className="section-title">
                        <span className="revamp-section-badge">our Recent product</span>
                        <h1 className="revamp-section-title">Explore our awesome products</h1>
                    </div>
                </div>
            </div>
            
            <div className="row">
                {products.map((item, index) => (
                    <div className="col-xl-4 col-md-6 mb-4" key={index}>
                        <div className="revamp-product-card">
                            <div className="revamp-product-thumb" style={{backgroundImage: `url('${item.img}')`}}></div>
                            <div className="revamp-product-content">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                                <a href={item.link} target="_blank" rel="noopener noreferrer" className="theme-btn">Explore <i className="fas fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>

    <CallToAction />
  </>
  );
}

export default Products;